import template from './legacy-root.component.html';
import './style.less';

export const legacyRootComponent = {
	template
};
